import React, { useState } from "react";

import {
    KeyboardDateTimePicker,
    MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";

import Selects from "./Select";

const InputItem = ({
    width,
    name,
    select,
    type,
    initialValue,
    placeholder,
    warning,
    forRef,
    inputHandler,
}) => {
    const [selectedDate, handleDateChange] = useState(new Date());
    return (
        <div className={`${width || "w-full lg:w-[48%]"} flex flex-col`}>
            <span className="size-sm text-kadComponentActive font-normal uppercase mb-2">
                {name} <span className="text-kad-gradient">{warning}</span>
            </span>
            <div>
                {!select && (
                    <>
                        {type ? (
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDateTimePicker
                                    variant="inline"
                                    value={selectedDate}
                                    onChange={handleDateChange}
                                    style={{
                                        padding: "5px 0",
                                        color: "#fff",
                                        width: "100%",
                                    }}
                                    InputProps={{
                                        disableUnderline: true,
                                    }}
                                    format="yyyy/MM/dd HH:mm"
                                />
                                <input
                                    ref={forRef}
                                    value={selectedDate}
                                    style={{ display: "none" }}
                                    placeholder={placeholder}
                                />
                            </MuiPickersUtilsProvider>
                        ) : (
                            <input
                                ref={forRef}
                                className="smooth-input w-full"
                                placeholder={placeholder}
                                onChange={inputHandler}
                            />
                        )}
                    </>
                )}
                {select && (
                    <Selects
                        forRef2={forRef}
                        select={select}
                        initialValue={initialValue}
                        handler={inputHandler}
                    />
                )}
            </div>
            <div className="hidden">
                <div className="MuiInputBase-root MuiSvgIcon-root MuiInput-formControl" />
            </div>
        </div>
    );
};
export default InputItem;
